import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  divider: {
    margin: '0.75rem 0',
    width: '50%'
  },

  color: {
    margin: '0.75rem 0'
  },

  input: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0 1rem 0',
    height: '40px',
    paddingBottom: '0.25rem',

    '& input': {
      flex: '1',
      border: 'none',
      outline: 'none'
    },
    '& label': {
      cursor: 'not-allowed',
      color: 'grey'
    }
  },

  dropdown: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0',

    '& > :first-child': {
      marginRight: '0.5rem'
    },

    '& .menu': {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${theme.border.outline}`,
      borderRadius: '5px',
      boxSizing: 'border-box',
      padding: '0.25rem',
      '& svg': {
        height: '0.75rem',
        width: '0.75rem'
      },

      '& > :first-child': {
        color: theme.palette.textAlt,
        marginRight: '1rem'
      }
    }
  },

  userSection: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0',
    minHeight: 25,

    '& > :first-child': {
      marginRight: '0.5rem'
    },
    '& > :nth-child(2) > div ': {
      marginTop: 0
    },
    '& > :nth-child(2) ': {
      marginTop: 0
    },
    '& .icon': {
      marginLeft: '0.5rem'
    }
  },

  warning: {
    color: theme.palette.indicator.red
  },

  info: {
    color: 'grey',

    '& strong': {}
  }
}))

export default useStyles
